module.exports = __webpack_public_path__ + "static/media/all-health-sm.ab39dec7.svg";